// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XYIv","colBig":"styles_colBig__36MIw","colSmall":"styles_colSmall__2XeSS"};